import { API_ENDPOINTS } from "./apiCall";

const API_BASE_URL = API_ENDPOINTS.API_COMMAN_URL +'Excel/';

export const EXCEL_API_ENDPOINTS = {
    
   ORDERMANAGEMENT_VALIDATE_EXCEL_BULK_UPLOAD: `${API_BASE_URL}ValidateExcelData`,
    ORDERMANAGEMENT_VALIDATE_EXCEL_BULK_UPLOAD_VALIDATION: `${API_BASE_URL}Validate`,
     ORDERMANAGEMENT_VALIDATE_EXCEL_BULK_UPLOAD_CONSTRUCT_PRODUCTCODE: `${API_BASE_URL}ConstructProductCode`,
     ORDERMANAGEMENT_SAVE_EXCEL_INDENT_DETAILS: `${API_BASE_URL}SaveExcelOrder`,
};
